module.exports = __webpack_public_path__ + "img/img5zhTc.35888c28.png";